import { Phone, PhoneFormData } from '../types/Phone';
import authService from './AuthService';
import { getApiUrl } from '../utils/env';

const API_BASE_URL = getApiUrl();

// Log API-Konfiguration beim Laden des Services
console.log('🔧 PhoneService Konfiguration:');
console.log('   API_BASE_URL (verwendet):', API_BASE_URL);
if (!process.env.REACT_APP_API_URL && !window.__ENV__?.REACT_APP_API_URL) {
  console.warn('⚠️  Keine API URL konfiguriert - verwende Default');
}

class PhoneService {
  private async getAuthHeaders() {
    const token = await authService.getAccessTokenAsync();
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };
  }

  async getAllPhones(): Promise<Phone[]> {
    console.log('📱 API Call: GET', `${API_BASE_URL}/phones`);
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/phones`, {
      method: 'GET',
      headers
    });

    console.log('📱 API Response:', response.status, 'GET /phones');
    if (!response.ok) {
      console.error('❌ Phones API Error:', response.status, 'GET /phones');
      throw new Error(`Fehler beim Abrufen der Telefone: ${response.status}`);
    }

    return response.json();
  }

  async createPhone(phoneData: PhoneFormData): Promise<Phone> {
    console.log('📱 API Call: POST', `${API_BASE_URL}/phones`, phoneData);
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/phones`, {
      method: 'POST',
      headers,
      body: JSON.stringify(phoneData)
    });

    console.log('📱 API Response:', response.status, 'POST /phones');
    if (!response.ok) {
      console.error('❌ Create Phone API Error:', response.status, 'POST /phones');
      throw new Error(`Fehler beim Erstellen des Telefons: ${response.status}`);
    }

    return response.json();
  }

  async updatePhone(phoneId: string, phoneData: Partial<PhoneFormData>): Promise<Phone> {
    console.log('📱 API Call: PUT', `${API_BASE_URL}/phones/${phoneId}`, phoneData);
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/phones/${phoneId}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(phoneData)
    });

    console.log('📱 API Response:', response.status, `PUT /phones/${phoneId}`);
    if (!response.ok) {
      console.error('❌ Update Phone API Error:', response.status, `PUT /phones/${phoneId}`);
      throw new Error(`Fehler beim Aktualisieren des Telefons: ${response.status}`);
    }

    return response.json();
  }

  async deletePhone(phoneId: string): Promise<void> {
    console.log('📱 API Call: DELETE', `${API_BASE_URL}/phones/${phoneId}`);
    const headers = await this.getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/phones/${phoneId}`, {
      method: 'DELETE',
      headers
    });

    console.log('📱 API Response:', response.status, `DELETE /phones/${phoneId}`);
    if (!response.ok) {
      console.error('❌ Delete Phone API Error:', response.status, `DELETE /phones/${phoneId}`);
      throw new Error(`Fehler beim Löschen des Telefons: ${response.status}`);
    }
  }

  // Statische Hilfsfunktion für MAC-Adresse Validierung
  static isValidMacAddress(mac: string): boolean {
    const macRegex = /^([0-9A-F]{2}[:-]){5}([0-9A-F]{2})$/i;
    return macRegex.test(mac);
  }
}

export default new PhoneService();
